import React, { useState, useEffect } from 'react';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import TabPayment from './Components/TabPayment/TabPayment';
import styles from './UpdatePaymentPlanChangePaymentTypePageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const UpdatePaymentPlanChangePaymentTypePageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const [eventTracked, setEventTracked] = useState<boolean>(false);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);
  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Payment Plan Update',
          checkout_step_number: '2',
          is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);
  return (
    <div className={styles.wrapper}>
      <div className="Section--secondaryBg">
        <div className="Page-container PageContainer--transparent">
          <div className="Section Section--portal u-paddingTz">
            <main className="CreateRepaymentPlan u-paddingTz">
              <section className="CreateRepaymentPlan__section">
                <ChangePlanHeader Headingtext={PageData?.Heading} />

                {Model.FormModel.WithCallCenterPlan && (
                  <div className="CreateRepaymentPlan-introText">
                    {PageData.PaymentInformationText}
                  </div>
                )}
              </section>

              <TabPayment {...props} />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePaymentPlanChangePaymentTypePageData;
